module.exports = __webpack_public_path__ + "assets/svg/Icons/32/tag-gray-c25d23.svg";